define(function(require, exports, module) {
    var u = navigator.userAgent;
    var ua = "browser";
    var vs = "m";

    if (u.indexOf("jdapp") != -1) {
        ua = "jdapp";
    } else if (u.indexOf("MicroMessenger") != -1) {
        ua = "browser";
        vs = "wx";
    } else if (u.indexOf("iPad") != -1) {
        ua = "browser";
        vs = "pad";
    } else if(u.indexOf("JDJR-App") != -1 || u.indexOf("kepler") != -1) {
        ua = "jdjr";
        vs = "jdjr";
    } else {
        ua = "browser";
        vs = "m";
    }

    if (getVs() != "") {
        vs = getVs();
    }

    function getVs() {
        var vs = "";
        var href = location.href;
        if (href.indexOf("vs=") != -1) {
            var hrefArray = href.split("vs=");
            if (hrefArray.length > 1) {
                var vsStr = hrefArray[1];
                var reg = /^[a-z0-9A-Z]+/;
                var r = vsStr.match(reg);

                if (r != null) {
                    vs = r;
                }
            }
        }
        return vs;
    }

    function setVs(str) {
        var reg = /^\bvs=\b[a-z0-9A-Z]+/;
        if (str.indexOf("jdw.jd.hk") != -1) {
            if (str.indexOf("vs=") != -1) {
                str = str.replace(reg, "vs=" + vs);
            } else {
                if (str.indexOf("?") != -1) {
                    str = str + "&vs=" + vs;
                } else {
                    str = str + "?vs=" + vs;
                }
            }
        }
        return str;
    }

    module.exports.setVs = setVs;
    exports.ua = ua;
});



// WEBPACK FOOTER //
// ./src/js/unit/vs/vs.js